module.exports = __webpack_public_path__ + "img/AE5001-01.d24adf8a.jpg";